export default __webpack_public_path__ + "static/moneySong-f31536511a63ef87192a2bd50c9ac9be.png";